import React, { useEffect, useState } from 'react';
import { withNamespaces } from 'react-i18next';
import { authorization } from '../../../configs/system.configs';
import taskServices from '../../../services/taskServices';
import { getJsonFromUrl, onChangeCommentEditor } from '../../../utils/Utils';
import Editor from '../../UI/Editor';
import InvalidLink from '../InvalidLink';
import { useStyles } from '../styles';
import * as ConfigJSON from '../../../configs/server.configs';
import Swal from 'sweetalert2';
import LoadingIcon from '../../UI/Loading';
import Loading from '../../UI/Loading';

const EditComment = ({ t }) => {
  const classes = useStyles();

  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [users, setUsers] = useState([]);
  const [detail, setDetail] = useState();
  const [isUpload, setIsUpload] = useState(false);
  const [description, setDescription] = useState('');
  const [isCompleted, setIsCompleted] = useState(false);

  const queryUrl = getJsonFromUrl();
  const { companyId, commentId, token, taskId } = queryUrl || {};
  if (!companyId || !commentId || !token || !taskId) {
    return <InvalidLink />;
  }
  // check exist companyId , taskId
  // get list user for mentions
  const fetchDataMentions = async () => {
    try {
      const { data } = await taskServices.getListAssignUser({ companyId });
      setUsers(data);
    } catch (error) {}
  };

  // get detail by taskId
  const fetchDetailComment = async () => {
    try {
      const { data } = await taskServices.getByCommentId({ taskId, commentId });
      if (data) {
        setDetail(data);
        setDescription(data?.content);
      }
    } catch (error) {}
  };
  // show UI For mobile

  const inititalData = async () => {
    try {
      localStorage.setItem(authorization, token);
      await fetchDataMentions();
      await fetchDetailComment();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const isValidDescription = (description || '').replace(/<[^>]*>/g, '').trim().length > 0;

  const onSubmit = async () => {
    if (processing || !isValidDescription) return;
    setProcessing(true);
    try {
      const values = {
        content: description,
      };
      const { success, message } = await taskServices.updateComment(taskId, commentId, values);
      if (success) {
        setIsCompleted(true);
        window?.ReactNativeWebView?.postMessage('success');
      } else {
        Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
          },
        }).fire({
          icon: 'error',
          title: message,
        });
      }
    } catch (error) {
    } finally {
      setProcessing(false);
    }
  };

  useEffect(() => {
    inititalData();
  }, []);

  return (
    <div className={classes.container}>
      {loading || !detail ? (
        <Loading loading={loading} />
      ) : (
        <>
          <LoadingIcon loading={processing || isUpload} />
          {isCompleted && <input type="hidden" id="completed-webview" />}
          <div>
            <Editor
              data={detail?.content}
              onChangeCommentEditor={(editor) => onChangeCommentEditor(editor, setDescription, false)}
              feed={users}
              isReadOnly={false}
              setIsUpload={setIsUpload}
              minHeight={'100%'}
            />
          </div>

          <p>
            <span
              className={`material-icons${!isValidDescription || processing ? ' disabled' : ''}`}
              onClick={onSubmit}
              role="button"
              aria-disabled={!isValidDescription || processing}
              title={!isValidDescription ? t('task:task:enterContentBeforeSend') : t('task:task:send')}
            >
              send
            </span>
          </p>
        </>
      )}
    </div>
  );
};

export default withNamespaces('task')(EditComment);
